import { reduce } from 'ramda';
import { ZodTypeAny } from 'zod';

export const convertKeysToSchema = (
	values: string[],
	schemaValue: ZodTypeAny,
	initialValue: Record<string, ZodTypeAny> = {}
) =>
	reduce<string, Record<string, ZodTypeAny>>(
		(acc, value: string) => {
			return {
				...acc,
				[value]: schemaValue,
			};
		},
		initialValue,
		values
	);
